import type { Transition, Variants } from 'framer-motion';

export const authEase = [0.22, 1, 0.36, 1] as const;

export const authSpring = { type: 'spring' as const, stiffness: 260, damping: 28 };

export const authSpringSoft = { type: 'spring' as const, stiffness: 180, damping: 26 };

export const authTransition: Transition = { duration: 0.45, ease: authEase };

export const AUTH_ROUTE_ORDER = [
  '/login',
  '/register',
  '/verify-email',
  '/forgot-password',
  '/reset-password',
] as const;

export function getAuthRouteDirection(from: string, to: string): 1 | -1 {
  const a = AUTH_ROUTE_ORDER.indexOf(from as (typeof AUTH_ROUTE_ORDER)[number]);
  const b = AUTH_ROUTE_ORDER.indexOf(to as (typeof AUTH_ROUTE_ORDER)[number]);
  if (a === -1 || b === -1) return 1;
  return b >= a ? 1 : -1;
}

export const authFadeUp: Variants = {
  hidden: { opacity: 0, y: 12 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.45, delay: i * 0.06, ease: authEase },
  }),
};

export const authStaggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.07, delayChildren: 0.08 },
  },
};

export const authStaggerItem: Variants = {
  hidden: { opacity: 0, y: 10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: authEase },
  },
};

export const authCardEnter: Variants = {
  hidden: { opacity: 0, y: 16 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: authEase },
  },
};

export const authPageTransition: Variants = {
  enter: (direction: number) => ({
    opacity: 0,
    x: direction > 0 ? 24 : -24,
  }),
  center: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.38, ease: authEase },
  },
  exit: (direction: number) => ({
    opacity: 0,
    x: direction > 0 ? -12 : 12,
    transition: { duration: 0.2, ease: authEase },
  }),
};

export const authReveal: Variants = {
  hidden: { opacity: 0, y: 8 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.38, ease: authEase },
  },
};

export const AUTH_CARD_LAYOUT_ID = 'auth-main-card';

export const AUTH_LAUNCH_MESSAGES = [
  'Preparing your finance workspace…',
  'Loading operational intelligence…',
  'Launching dashboard systems…',
] as const;
